// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/assets/index.css'
import './permissions'
import './filter/filter.js'
// import moment from 'moment'

const vuetifyOptions = {}
Vue.config.productionTip = false
Vue.use(Vuetify, {
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>',
  vuetify: new Vuetify(vuetifyOptions)
})



// WEBPACK FOOTER //
// ./src/main.js